module.exports = __webpack_public_path__ + "static/media/celabrate.d1d41e1e.png";